<template>
  <Teleport to="body">
  <Transition name="invoice-frequency-modal-overlay">
    <div
      v-if="visible"
      class="invoice-frequency-modal-overlay invoice-frequency-modal-overlay--glass"
      @click.self="$emit('cancel')"
    >
      <Transition name="invoice-frequency-modal-panel" appear>
        <div
          v-if="visible"
          class="invoice-frequency-modal-card invoice-frequency-modal-card--glass"
          role="dialog"
          aria-modal="true"
          aria-labelledby="invoice-frequency-modal-title"
          @click.stop
        >
          <div class="invoice-frequency-modal-header invoice-frequency-modal-header--glass">
            <h2 id="invoice-frequency-modal-title" class="invoice-frequency-modal-title">
              Invoice Frequency
            </h2>
            <button
              type="button"
              class="invoice-frequency-modal-close-btn"
              aria-label="Close"
              title="Close"
              @click="$emit('cancel')"
            >
              <i class="bi bi-x-lg" aria-hidden="true"></i>
            </button>
          </div>

          <div class="invoice-frequency-modal-body invoice-frequency-modal-body--glass">
            <LabelInputField
              input-id="invoice-frequency-name"
              label="Name"
              v-model="frequencyName"
              placeholder="e.g. Monthly"
              required
              flex
              :has-error="!!error"
              :disabled="saving"
              @input="error = ''"
            >
              <div v-if="error" class="invoice-frequency-modal-error">{{ error }}</div>
            </LabelInputField>
          </div>

          <div class="invoice-frequency-modal-actions invoice-frequency-modal-actions--glass">
            <SecondaryButton label="Cancel" :disabled="saving" @click="$emit('cancel')" />
            <PrimaryButton label="Save" :loading="saving" @click="ok" />
          </div>
        </div>
      </Transition>
    </div>
  </Transition>

  <ErrorModal
    :show="showErrorModal"
    title="Validation Error"
    :message="errorMessage"
    buttonText="OK"
    @close="closeErrorModal"
  />
  </Teleport>
</template>

<script>
import '../styles/AddNewInvoiceFrequency.css';
import CompanyService from '@/services/company.service.js';
import ErrorModal from '@/components/ErrorModal.vue';
import LabelInputField from '@/modules/consultant/components/LabelInputField.vue';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';

export default {
  name: 'AddNewInvoiceFrequency',
  components: {
    ErrorModal,
    LabelInputField,
    PrimaryButton,
    SecondaryButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      frequencyName: '',
      error: '',
      saving: false,
      showErrorModal: false,
      errorMessage: '',
    };
  },
  methods: {
    async ok() {
      if (!this.frequencyName.trim()) {
        this.error = 'Name field is required.';
        return;
      }
      this.saving = true;
      this.error = '';
      try {
        const frequency = await CompanyService.createInvoiceFrequency({
          name: this.frequencyName.trim(),
          companyId: this.companyId,
        });
        this.$emit('ok', frequency);
        this.frequencyName = '';
        this.error = '';
      } catch (err) {
        this.errorMessage =
          err.response?.data?.message || err.message || 'Failed to create invoice frequency.';
        this.showErrorModal = true;
      } finally {
        this.saving = false;
      }
    },

    closeErrorModal() {
      this.showErrorModal = false;
      this.errorMessage = '';
    },
  },
};
</script>
